module.exports = __webpack_public_path__ + "assets/img/EISS-Super-eBook-w540.3765f497.webp";